export default __webpack_public_path__ + "static/media/k-club.07b45098.png";